export const getSubscriber = subscriberId => ({ subscribers }) =>
  subscribers.subscribersList.find(({ id }) => id === +subscriberId);
